/**
 * Daisi Backend API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

// @ts-ignore
import { RoadOperatorDto } from '../model/road-operator-dto';
import { Param } from '../param';
import { ApiConfigurationService } from '../../helpers/api-configuration.service';
import { HttpParamHelper } from '../../helpers/http-param-helper';
import { CustomHttpParameterCodec } from '../encoder';

import { COLLECTION_FORMATS } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class RoadOperatorControllerService {
  private readonly encoder: CustomHttpParameterCodec;
  private readonly httpClient = inject(HttpClient);
  protected readonly configuration = inject(ApiConfigurationService);

  constructor() {
    this.encoder = this.configuration.encoder;
  }

  public getAllRoadOperators(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<RoadOperatorDto>>;
  public getAllRoadOperators(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<RoadOperatorDto>>>;
  public getAllRoadOperators(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<RoadOperatorDto>>>;
  public getAllRoadOperators(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<Array<RoadOperatorDto>>('get', `/api/road-operators`, {
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }

  public updateRoadOperators(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public updateRoadOperators(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public updateRoadOperators(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public updateRoadOperators(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<any>('post', `/api/road-operators/update-database`, {
      observe: observe,
    });
  }
}
